import { View as NbView } from 'native-base';

import { addWithConfig } from '../../utils';

export const View = NbView;

export default addWithConfig(View);
